import { ToastWidget } from '@tableau/widgets';
import React from 'react';
import { useEffect, useState } from 'react';

import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { PopupToasterStyle } from '~src/spacesPlatform/components/layout/ToasterStyles';

import { RootSpaceRouter } from '../../app/spaces/RouterHelpers/RootSpaceRouter';
import { NavigationTelemetry } from '../../app/spaces/RouterHelpers/TelemetryRouter';
import { ConnectedRootAdminUi } from '../../rootAdminUi/ConnectedRootAdminUi';
import { RootAdminUiState } from '../../rootAdminUi/RootAdminUIState';

interface IAppAdminStateScope {
  displayDefault: boolean;
  displayInnerApp: boolean;
}

export type AppRootOwnProps = {
}

export type AppRootStateProps = {
  rootAdminUiState: RootAdminUiState;
}

export type AppRootProps = AppRootStateProps & AppRootOwnProps;

export function AppRoot(props: AppRootProps): JSX.Element {
  // Note: using local state and effect to determine whicj child components to display since removing these seemingly extra state and effects seems
  // to cause a lot of things to fail (odd UI screen displayed, integration test failures). My guess is it's a timing issue perhaps related to moving
  // away from angular while angualr is still being used in places. Craeting a story TFS 1281215 to come back to this component and try removing local
  // state and effect and instead use props.rootAdminUiState directly to determine which child componets are displayed.
  const [adminStateScope, setAdminStateScope] = useState<IAppAdminStateScope>({
    displayDefault : false,
    displayInnerApp : false
});

  // hook to record performance metrics for page load using api window.performance.timing
  useEffect(() => {
    function onLoad() {
      // 'performance' may be null if the browser does not support the Navigation Timing API
      // 'timing' may be null if the browser user has disabled this feature
      //         (as per http://www.w3.org/TR/navigation-timing/#processing-model)
      if (window.performance && window.performance.timing) {
        const sessionManagementService = getSessionManagementServiceInstance();
        sessionManagementService.recordNavigationTiming(window.performance.timing);
      }
    }
    window.addEventListener('load', onLoad);
    return () => {
      window.removeEventListener('load', onLoad);
    };
  }, []);

  useEffect(() => ToastWidget.initToaster(PopupToasterStyle), []);

  useEffect(() => {
    const newDisplayDefault: boolean =  props.rootAdminUiState === 'default';
    const newDisplayInnerApp: boolean = props.rootAdminUiState !== 'default' && props.rootAdminUiState !== 'bootstrap';
    if(adminStateScope.displayDefault !== newDisplayDefault || adminStateScope.displayInnerApp !== newDisplayInnerApp){
        setAdminStateScope({
          displayDefault : newDisplayDefault,
          displayInnerApp : newDisplayInnerApp
      });
      }
  }, [props.rootAdminUiState, adminStateScope.displayDefault, adminStateScope.displayInnerApp]);

  return (
      <div className="tb-app-inner">
          { adminStateScope.displayInnerApp ? <div><ConnectedRootAdminUi /></div> : null }
          { adminStateScope.displayDefault ? <div><RootSpaceRouter /></div> : null }
          { adminStateScope.displayDefault ? <div><NavigationTelemetry /></div> : null }
      </div>
    );
}
